import * as React from "react";
import { useDrawerDirection, Drawer } from "@grandvisionhq/common";
const PrescriptionInformationDrawer = ({
  title,
  trigger,
  children,
  "data-t": dataT
}) => {
  const drawerDirection = useDrawerDirection();
  const isRightDirection = drawerDirection === "right";
  const Title = /* @__PURE__ */ React.createElement(Drawer.Title, null, title);
  return /* @__PURE__ */ React.createElement(Drawer, { direction: drawerDirection }, trigger, /* @__PURE__ */ React.createElement(Drawer.Portal, null, /* @__PURE__ */ React.createElement(Drawer.Backdrop, null), /* @__PURE__ */ React.createElement(Drawer.Overlay, { "data-t": dataT }, /* @__PURE__ */ React.createElement(Drawer.Header, { LeftSlot: !isRightDirection && Title, RightSlot: /* @__PURE__ */ React.createElement(Drawer.CloseButton, null) }), !isRightDirection && /* @__PURE__ */ React.createElement(Drawer.Divider, null), /* @__PURE__ */ React.createElement(Drawer.Content, null, isRightDirection && Title, children))));
};
export {
  PrescriptionInformationDrawer
};
//# sourceMappingURL=PrescriptionInformationDrawer.js.map
